import React from 'react'
import PropTypes from 'prop-types'

export const Table = ({children, style}) => (
  <div data-test='Table' style={style}>
    {children}
  </div>
)

Table.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default Table
